<template>
  <div
    class="card pl-4 pr-4 pb-4 pt-4 mt-4 mt-md-2"
    v-if="
      status === 'active '
        ? totalUserPage || search
        : totalBannedUserPage || search
    "
  >
    <div class="card-header border-0 pl-2 pt-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">
            {{ status === 'active' ? 'User Info' : 'Banned User Info' }}
          </h3>
        </div>
        <div class="col-3">
          <base-input
            alternative
            placeholder="Search by name"
            v-model="search"
            class="mb-0"
            @input="onSearch()"
          />
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="status === 'active' ? users : bannedUsers">
        <template slot="columns">
          <th>Profile</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          <th v-if="status === 'disabled' && !isStreamer">Banned By</th>
          <th>Ban</th>
        </template>

        <template slot-scope="{ row }">
          <td class="td-profile">
            <span class="avatar avatar-sm rounded-circle">
              <img
                :src="
                  row.profile
                    ? row.profile
                    : require('@/assets/default_profile_picture.png')
                "
              />
            </span>
          </td>
          <td>{{ row.firstName }}</td>
          <td>{{ row.lastName }}</td>
          <td>{{ row.email }}</td>
          <th v-if="status === 'disabled' && !isStreamer">{{ row.bannedBy ? (row.bannedBy.firstName + ' ' + row.bannedBy.lastName) : '' }}</th>
          <td class="pl-1">
            <button
              class="btn"
              :class="{
                'btn-success': row.status === 'disabled',
                'btn-delete': row.status === 'active',
              }"
              @click="onBanClicked(row)"
            >
              {{ row.status === 'active' ? 'Ban' : 'Unban' }}
            </button>
          </td>
        </template>
      </base-table>
      <div
        class="card-footer d-flex justify-content-center"
        v-if="status === 'active' ? totalUserPage : totalBannedUserPage"
      >
        <base-pagination
          :page-count="
            status === 'active' ? totalUserPage : totalBannedUserPage
          "
          v-model="pagination"
          @input="onPageChanged"
        ></base-pagination>
      </div>

      <div
        class="text-center mt-4"
        v-if="status === 'active' ? !totalUserPage : !totalBannedUserPage"
      >
        No users was found
      </div>
    </div>
    <confirmation-modal
      type="danger"
      :isLoading="isLoading"
      :showModal.sync="showModal"
      message="Are you sure want to ban this user?"
      positiveText="Ban"
      negativeText="Cancel"
      @onPositiveClicked="onPositiveClicked()"
      @onNegativeClicked="onNegativeClicked()"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  GET_USERS,
  UPDATE_USER_STATUS,
  GET_BANNED_USERS
} from '@/store/actions.type'

export default {
  name: 'user-info-table',
  props: ['status'],
  data() {
    return {
      pagination: 1,
      selectedUser: null,
      showModal: false,
      search: '',
      debounce: null
    }
  },
  created() {
    this.getUsers()
  },
  methods: {
    onPageChanged(page) {
      this.getUsers()
    },
    onBanClicked(user) {
      if (user.status === 'active') {
        this.selectedUser = user
        this.showModal = true
      } else {
        this.$store
          .dispatch(UPDATE_USER_STATUS, {
            id: user.id,
            status: 'active'
          })
          .then(() => {
            this.getUsers()
          })
      }
    },
    onPositiveClicked() {
      this.$store
        .dispatch(UPDATE_USER_STATUS, {
          id: this.selectedUser.id,
          status: 'disabled'
        })
        .then(() => {
          this.showModal = false
          this.getUsers()
        })
    },
    onNegativeClicked() {
      this.showModal = false
    },
    onSearch() {
      if (this.search === '') {
        if (this.status === 'active') {
          this.$store.dispatch(GET_USERS, {
            role: 'user',
            page: 1,
            query: ''
          })
        } else {
          var streamerId = this.isStreamer ? this.currentUser.id : null
          this.$store.dispatch(GET_BANNED_USERS, {
            page: this.pagination,
            query: '',
            streamerId
          })
        }
      } else {
        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          if (this.status === 'active') {
            this.$store.dispatch(GET_USERS, {
              role: 'user',
              page: 1,
              query: this.search
            })
          } else {
            this.$store.dispatch(GET_BANNED_USERS, {
              page: 1,
              query: this.search
            })
          }
        }, 500)
      }
    },
    getUsers() {
      if (this.status === 'active') {
        this.$store.dispatch(GET_USERS, {
          role: 'user',
          page: this.pagination,
          query: this.search
        })
      } else {
        var streamerId = this.isStreamer ? this.currentUser.id : null
        this.$store.dispatch(GET_BANNED_USERS, {
          page: this.pagination,
          query: this.search,
          streamerId
        })
      }
    }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.user.isLoading,
      error: (state) => state.user.errror
    }),
    ...mapGetters([
      'totalUserPage',
      'users',
      'totalBannedUserPage',
      'bannedUsers',
      'currentUser',
      'isStreamer'
    ])
  }
}
</script>

<style scoped>
.btn-delete {
  padding: 0.35rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  background-color: #f65858;
}
.btn-success {
  padding: 0.45rem 0.9rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}
.btn-delete:hover {
  background-color: #f65858;
}
.btn-cancel {
  border-color: #f65858 !important;
  color: #f65858 !important;
}
.btn-cancel:hover {
  background-color: transparent !important;
}
.default-button {
  padding: 0.625rem 1.25rem !important;
  font-size: 0.875em !important;
}
</style>
